import React from 'react';
import CtPrivacyTable from './table/CtPrivacyTable';

const PrivacyContent: React.FC = () => {
  return <CtPrivacyTable />;
};

export default PrivacyContent;
